import type { RegrelloFormFieldSelfContainedFormProps } from "../RegrelloFormFieldLayout";

export function getSelfContainedFormInternal<T>(
  selfContainedForm: Omit<RegrelloFormFieldSelfContainedFormProps<T>, "getDisplayValue"> | undefined,
  getDisplayValue: RegrelloFormFieldSelfContainedFormProps<T>["getDisplayValue"],
) {
  return selfContainedForm == null ? undefined : { ...selfContainedForm, getDisplayValue };
}
